import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/yeppy/service_usage.png";

const Serviceusageyeppy = () => {
  return (
    <div
      className="serviceusage_yeppy"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-7 offset-lg-7 my-auto"
          >
            <h2>Service Usage Service</h2>
            <ul>
              <li>Financial Services</li>
              <p>
                Financial services were consistently used more frequently and
                for longer durations than other features. Users often accessed
                this section to manage their finances, check balances, and make
                transactions.
              </p>
              <li>Retail Services</li>
              <p>
                Retail services were the second most frequently used feature.
                Users shopped for a wide range of products and took advantage of
                discounts and deals.
              </p>
              <li>Booking Services</li>
              <p>
                Booking services, including hotel reservations and car rentals,
                ranked third in terms of user engagement. Users frequently
                planned trips and accommodations through the app.
              </p>
              <li>Exclusive Services</li>
              <p>
                While Exclusive services had a dedicated user base, it didn't
                experience the same level of user engagement as the previous
                three categories.
              </p>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Serviceusageyeppy;
